import { render } from "./HeaderWebsite.vue?vue&type=template&id=56620e49"
import script from "./HeaderWebsite.vue?vue&type=script&lang=js"
export * from "./HeaderWebsite.vue?vue&type=script&lang=js"

import "./HeaderWebsite.vue?vue&type=style&index=0&id=56620e49&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__